import type { KeyboardEvent } from 'react';
import { cn } from '@/lib/utils';

interface TabSwitcherProps {
  tabs: Array<{ id: string; label: string }>;
  activeTab: string;
  onChange: (id: string) => void;
  className?: string;
}

export function TabSwitcher({ tabs, activeTab, onChange, className }: TabSwitcherProps) {
  const handleKeyDown = (e: KeyboardEvent<HTMLButtonElement>, index: number) => {
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      const next = tabs[(index + 1) % tabs.length];
      if (next) onChange(next.id);
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      const prev = tabs[(index - 1 + tabs.length) % tabs.length];
      if (prev) onChange(prev.id);
    }
  };

  return (
    <div role="tablist" className={cn('flex w-full border-b border-dream-navy/20', className)}>
      {tabs.map((tab, i) => {
        const isActive = tab.id === activeTab;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            tabIndex={isActive ? 0 : -1}
            onClick={() => onChange(tab.id)}
            onKeyDown={(e) => handleKeyDown(e, i)}
            className={cn(
              'flex h-11 flex-1 items-center justify-center text-sm text-dream-navy transition-colors',
              isActive
                ? '-mb-px border-b-2 border-dream-gold font-bold'
                : 'border-b-2 border-transparent opacity-50',
            )}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
